<script>
    import { UserService } from "../services/UserService";
    import { BackgroundService } from "../services/BackgroundService";
    import { TenantStore } from "../stores/TenantStore";
    import { clickAction } from "$/utils/clickAction";
    import { ActiveTopicStore, ActiveTopic } from "$/stores/extension/ActiveTopicStore";

    let UserServiceImpl = chrome?.storage ? BackgroundService : UserService;

    export let tenantOwner;

    let username = "";

    let notValidEmail = false;
    let usernameExists = false;
    let waitingUsernameValidation = false;

    $: showEmailError =
        !usernameExists &&
        username !== "" &&
        !waitingUsernameValidation &&
        !notValidEmail;
    $: showOwnerError = username === tenantOwner.username;
    $: showError =
        showEmailError || showOwnerError || (notValidEmail && username !== "");
    $: submitAllowed =
        username !== "" &&
        !waitingUsernameValidation &&
        username !== tenantOwner.username &&
        !notValidEmail;

    $: {
        if (username === "") usernameExists = false;
        else debounceCheckUsernameExists();
    }

    let timer;
    function debounceCheckUsernameExists() {
        clearTimeout(timer);

        waitingUsernameValidation = true;

        timer = setTimeout(async () => {
            
            const notValidEmail = !username.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+$/);

            console.log("notValidEmail: ", notValidEmail);
            console.log("username: ", username);

            if (!notValidEmail)
                usernameExists = await UserServiceImpl.usernameExists(username);

            waitingUsernameValidation = false;
        }, 500);
    }

    async function addAuthority() {
        let authority = {
            authority: "ROLE_USER",
            user: {
                username,
            },
        };

        let newAuthority = await TenantStore.createAuthority(authority);

        if ($ActiveTopic) {
            ActiveTopicStore.addCollaborator(newAuthority.user);
        }

        username = "";
    }

    function handleKeyDown(event) {
        if (event.key === "Enter" && submitAllowed) {
            addAuthority();
        }
    }
</script>

<div class="add-authority">
    <div class="main-content" class:main-content-invalid={showError}>
        <input
            class="email-input"
            placeholder="Email address"
            name="email"
            bind:value={username}
            on:keydown={handleKeyDown}
        />

        {#if submitAllowed}
            <div class="add-authority__icon" use:clickAction={addAuthority}>
                {#if usernameExists}
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="h-6 w-6"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M19 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zM4 19.235v-.11a6.375 6.375 0 0112.75 0v.109A12.318 12.318 0 0110.374 21c-2.331 0-4.512-.645-6.374-1.766z"
                        />
                    </svg>
                {:else}
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="h-6 w-6"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
                        />
                    </svg>
                {/if}
            </div>
        {/if}
    </div>

    {#if notValidEmail && username !== ""}
        <span class="incorrect-email">
            This doesn't look like a valid email address.
        </span>
    {/if}

    {#if showEmailError}
        <span class="incorrect-email">
            No users found with this email. Click the envelope above to <b
                >invite them over email</b
            >.
        </span>
    {/if}

    {#if showOwnerError}
        <span class="incorrect-email">
            They are already a member silly 🙃
        </span>
    {/if}
</div>

<style>
    @import "../main.css";

    .add-authority {
        @apply flex flex-col gap-1 !important;
    }

    .email-input {
        @apply w-full bg-transparent text-sm outline-none !important;
    }

    .incorrect-email {
        @apply ml-6 text-xs text-pink-500 !important;
    }

    .main-content {
        @apply flex flex-row items-center gap-1 rounded-full border border-gray-200 bg-white p-4 !important;
    }

    .main-content-invalid {
        @apply flex flex-row items-center gap-1 rounded-full border border-pink-500 bg-white p-4 !important;
    }

    .add-authority__icon {
        @apply flex h-4 min-h-fit w-4 min-w-fit cursor-pointer items-center overflow-visible !important;
    }

    .add-authority__icon svg {
        @apply reset h-5 w-5 cursor-pointer !important;
    }
</style>
